import { create } from 'zustand';
import { Employee, Department, Position } from '../types';

interface HrEmployeeState {
  employees: Employee[];
  activeEmployee: Employee | null;
  departments: Department[];
  positions: Position[];
  totalEmployees: number;
  currentPage: number;
  pageSize: number;
  searchTerm: string;
  statusFilter: string;
  departmentFilter: number | null;
  isLoading: boolean;

  setEmployees: (employees: Employee[], total?: number) => void;
  setActiveEmployee: (employee: Employee | null) => void;
  setDepartments: (departments: Department[]) => void;
  setPositions: (positions: Position[]) => void;
  setCurrentPage: (page: number) => void;
  setSearchTerm: (term: string) => void;
  setStatusFilter: (status: string) => void;
  setDepartmentFilter: (deptId: number | null) => void;
  setLoading: (loading: boolean) => void;
  resetFilters: () => void;
}

export const useHrEmployeeStore = create<HrEmployeeState>((set) => ({
  employees: [],
  activeEmployee: null,
  departments: [],
  positions: [],
  totalEmployees: 0,
  currentPage: 0,
  pageSize: 20,
  searchTerm: '',
  statusFilter: '',
  departmentFilter: null,
  isLoading: false,

  setEmployees: (employees, total) => set({ employees, totalEmployees: total ?? employees.length }),
  setActiveEmployee: (activeEmployee) => set({ activeEmployee }),
  setDepartments: (departments) => set({ departments }),
  setPositions: (positions) => set({ positions }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setSearchTerm: (searchTerm) => set({ searchTerm }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setDepartmentFilter: (departmentFilter) => set({ departmentFilter }),
  setLoading: (isLoading) => set({ isLoading }),
  resetFilters: () => set({ searchTerm: '', statusFilter: '', departmentFilter: null, currentPage: 0 }),
}));
